{
  "zh-CN": {
    "baseChip": {
      "states": {
        "included": "已包含",
        "excluded": "已排除"
      },
      "sortHint": "使用方向键移动"
    }
  }
}
